import React from "react";
import { Button } from "react-md";
import { MCard, MDialog } from "components/Shared";
import { UserUnderwriter } from "interfaces/Mueller.Business.Models";

interface UserUnderwriterDeleteDialogProps {
  underwriter: UserUnderwriter;
  onCancel: () => void;
  onConfirm: (underwriterId: Number) => void;
  visible: boolean;
}

const UserUnderwriterDeleteDialog = (props: UserUnderwriterDeleteDialogProps) => {

  const handleDeleteConfirmClick = () => {
    props.onConfirm(props.underwriter.id);
  };

  return (
    <MDialog
      className="remove-user-underwriter-dialog"
      visible={props.visible}
      children={
        <MCard
          key="remove-user-underwriter-dialog-mcard"
          title="Remove Underwriter"
        >
          <div className="remove-user-underwriter-card-text">
            {`Do you want to remove ${props.underwriter.underwriterCode}? This action cannot be undone.`}
          </div>
          <div className="remove-user-underwriter-card-text-code">
            {``}
          </div>
          <div className="user-underwriter-delete-buttons-container">
            <Button primary raised onClick={handleDeleteConfirmClick}>Confirm</Button>
            <Button primary raised onClick={props.onCancel}>Cancel</Button>
          </div>
        </MCard>
      }
    />
  );
};

export default UserUnderwriterDeleteDialog;